import Vue from 'vue'
import axios from 'axios'
// import mock from './mock-adapter'

const http = axios.create() // process.env.NODE_ENV !== 'production' ? mock.create() : axios.create()

// add request interceptor
axios.interceptors.request.use(
  (config) => {
    // do something before request is sent
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return config
  },
  (error) => {
    // do something with request error
    return Promise.reject(error)
  }
)

// add response interceptors
axios.interceptors.response.use(
  (response) => {
    // Do something with response data
    // console.debug(`Response from interceptor: ${response}`)
    return response
  },
  (error) => {
    // TODO: Are we logging these errors?
    // console.debug(`Error from interceptor: ${error}`)
    // console.debug(`Error from interceptor: ${error.response}`)
    // console.debug(`Error from interceptor: ${error.request}`)
    // console.debug(`Error from interceptor: ${error.message}`)
    // console.debug(`Error from interceptor: ${error.config}`)
    return Promise.reject(error)
  }
)

// Axios Common Base Instance (resource: https://goo.gl/sDN0IN)
export default {
  auth: (data, callback, error) => {
    axios.post(window.config.authService, data).then(callback).catch(error)
  },
  get: (endpoint, data = {}) => {
    return axios.get(`${window.config.apiUrl}${endpoint}`, data)
  },
  post: (endpoint, data = {}, config = {}) => {
    return axios.post(`${window.config.apiUrl}${endpoint}`, data, config)
  },
  put: (endpoint, data = {}, config = {}) => {
    return axios.put(`${window.config.apiUrl}${endpoint}`, data, config)
  },
  postWithJson: (endpoint, data = {}, config = {}) => {
    const json = JSON.stringify(data)
    return axios.post(`${window.config.apiUrl}${endpoint}`, json, {
      headers: {
        // Overwrite Axios's automatically set Content-Type
        'Content-Type': 'application/json'
      }})
  },
  delete: (endpoint, data = {}) => {
    return axios.delete(`${window.config.apiUrl}${endpoint}`, data)
  }
}

// Add 'http' as a Vue property
Object.defineProperties(Vue.prototype, {
  $http: {
    get() {
      return http
    }
  }
})



// WEBPACK FOOTER //
// ./src/api/common.js